// extracted by mini-css-extract-plugin
export default {"formItem":"FormItem_formItem__vHVfn","formItemInput":"FormItem_formItemInput__lhShe","fontSize":"FormItem_fontSize__KthXj","radioGroup":"FormItem_radioGroup__k8Tzy"};